<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3>{{ label.get("notifications_reminders") }}</h3>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get("notifications") }}</label>
            <!-- <i class="atto info-icon"
               id="tooltip-user-notifications"></i>
            <b-tooltip
                target="tooltip-user-notifications"
                custom-class="info-tooltip"
                placement="bottom" >
              <label>{{ label.get('notifications') }}</label>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
            </b-tooltip>-->
          </div>
        </div>
        <div class="notifications subsection-wrapper">
          <div class="field-wrap mb-32">
            <div class="check-wrapper">
              <b-form-checkbox
                v-model="userSettings.reminders.clockin12hours"
                @change="saveChanges"
              >
                {{ label.get("notification_clocked_in_12_hours") }}
              </b-form-checkbox>
              <p>
                {{ label.get("notification_clocked_in_12_hours_description") }}
              </p>
            </div>
          </div>
          <div class="field-wrap">
            <div class="check-wrapper">
              <b-form-checkbox
                v-model="userSettings.reminders.clockin24hours"
                @change="saveChanges"
              >
                {{ label.get("notification_clocked_in_24_hours") }}
              </b-form-checkbox>
              <p>
                {{ label.get("notification_clocked_in_24_hours_description") }}
              </p>
            </div>
          </div>
          <hr class="separator-line" />
          <div class="d-flex flex-row">
            <div class="d-flex flex-column col-md-4 p-0">
              <div v-if="user.role_id !== 3" class="field-wrap">
                <div class="check-wrapper">
                  <b-form-checkbox
                    v-model="userSettings.clockin"
                    @change="saveChanges"
                  >
                    {{ label.get("notification_when_user_clocks_in") }}
                  </b-form-checkbox>
                </div>
              </div>
              <div v-if="user.role_id !== 3" class="field-wrap">
                <div class="check-wrapper">
                  <b-form-checkbox
                    v-model="userSettings.clockout"
                    @change="saveChanges"
                  >
                    {{ label.get("notification_when_user_clocks_out") }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column col-md-4 p-0">
              <div v-if="user.role_id !== 3" class="field-wrap">
                <div class="check-wrapper class">
                  <b-form-checkbox
                    v-model="userSettings.employees_take_break"
                    @change="saveChanges"
                  >
                    {{ label.get("notification_when_user_start_break") }}
                  </b-form-checkbox>
                </div>
              </div>
              <div v-if="user.role_id !== 3" class="field-wrap">
                <div class="check-wrapper">
                  <b-form-checkbox
                    v-model="userSettings.employees_leave_break"
                    @change="saveChanges"
                  >
                    {{ label.get("notification_when_user_end_break") }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column col-md-4 p-0">
              <div v-if="user.role_id !== 3" class="field-wrap">
                <div class="check-wrapper">
                  <b-form-checkbox
                    v-model="userSettings.manual_entry"
                    @change="saveChanges"
                  >
                    {{ label.get("notification_when_time_entry_modified") }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get("reminders") }}</label>
            <!--  <i class="atto info-icon"
               id="tooltip-user-reminders"></i>
            <b-tooltip
                target="tooltip-user-reminders"
                custom-class="info-tooltip"
                placement="bottom" >
              <label>{{ label.get('reminders') }}</label>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
            </b-tooltip>-->
          </div>
        </div>
        <div class="reminders subsection-wrapper">
          <div class="field-wrap">
            <div class="check-wrapper">
              <b-form-checkbox
                v-model="userSettings.reminders.clockin_reminder_check"
                @change="saveChanges"
              >
                {{ label.get("notification_clock_in_reminder") }}
              </b-form-checkbox>
            </div>
            <div
              class="time-reminder"
              :class="{
                disabled: !userSettings.reminders.clockin_reminder_check,
              }"
            >
              <i class="atto atto-rdir-arrow-b" />
              <span class="remind-me">
                {{ label.get("notification_remind_me_at") }}:
              </span>
              <time-picker-component
                v-model="clockInReminder"
                :required="true"
              />
              <span class="input-overlay" />
            </div>
          </div>
          <div class="field-wrap">
            <div class="check-wrapper">
              <b-form-checkbox
                v-model="userSettings.reminders.clockout_reminder_check"
                @change="saveChanges"
              >
                {{ label.get("notification_clock_out_reminder") }}
              </b-form-checkbox>
            </div>
            <div
              class="time-reminder"
              :class="{
                disabled: !userSettings.reminders.clockout_reminder_check,
              }"
            >
              <i class="atto atto-rdir-arrow-b" />
              <span class="remind-me">
                {{ label.get("notification_remind_me_at") }}:
              </span>
              <time-picker-component
                v-model="clockOutReminder"
                :required="true"
              />
              <span class="input-overlay" />
            </div>
          </div>
          <hr class="separator-line" />
          <div class="field-wrap">
            <div class="check-wrapper">
              <b-form-checkbox
                v-model="userSettings.enter_job_site"
                @change="saveChanges"
              >
                {{ label.get("notification_when_enter_job_site") }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="field-wrap">
            <div class="check-wrapper">
              <b-form-checkbox
                v-model="userSettings.leave_job_site"
                @change="saveChanges"
              >
                {{ label.get("notification_when_leave_job_site") }}
              </b-form-checkbox>
            </div>
          </div>
          <hr class="separator-line" />
          <div class="reminding-days">
            <span class="label">
              {{ label.get("days") }}
            </span>

            <ul class="day-list reminders-day-list">
              <li>
                <b-form-checkbox
                  v-model="userSettings.reminders.working_day_monday"
                  button
                  @change="saveChanges"
                >
                  {{ label.get("monday") | truncate }}
                </b-form-checkbox>
              </li>
              <li>
                <b-form-checkbox
                  v-model="userSettings.reminders.working_day_tuesday"
                  button
                  @change="saveChanges"
                >
                  {{ label.get("tuesday") | truncate }}
                </b-form-checkbox>
              </li>
              <li>
                <b-form-checkbox
                  v-model="userSettings.reminders.working_day_wednesday"
                  button
                  @change="saveChanges"
                >
                  {{ label.get("wednesday") | truncate }}
                </b-form-checkbox>
              </li>
              <li>
                <b-form-checkbox
                  v-model="userSettings.reminders.working_day_thursday"
                  button
                  @change="saveChanges"
                >
                  {{ label.get("thursday") | truncate }}
                </b-form-checkbox>
              </li>
              <li>
                <b-form-checkbox
                  v-model="userSettings.reminders.working_day_friday"
                  button
                  @change="saveChanges"
                >
                  {{ label.get("friday") | truncate }}
                </b-form-checkbox>
              </li>
              <li>
                <b-form-checkbox
                  v-model="userSettings.reminders.working_day_saturday"
                  button
                  @change="saveChanges"
                >
                  {{ label.get("saturday") | truncate }}
                </b-form-checkbox>
              </li>
              <li>
                <b-form-checkbox
                  v-model="userSettings.reminders.working_day_sunday"
                  button
                  @change="saveChanges"
                >
                  {{ label.get("sunday") | truncate }}
                </b-form-checkbox>
              </li>
            </ul>
            <p>
              {{ label.get("notification_days_description") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../services/UserService";
import TimePickerComponent from "../../timesheets/shared/components/TimePickerComponent";

export default {
  name: "NotificationsComponent",
  components: {
    TimePickerComponent,
  },
  filters: {
    truncate(value) {
      if (value.length > 3) {
        value = value.substring(0, 3);
      }

      return value;
    },
  },
  data() {
    return {
      user: this.$store.state.user,
      userSettings: this.$store.state.userSettings,
      clockInReminder:
        this.$store.state.userSettings.reminders.clockin_reminder + ":00",
      clockOutReminder:
        this.$store.state.userSettings.reminders.clockout_reminder + ":00",
      oldClockInTime: this.$store.state.userSettings.reminders.clockin_reminder,
      oldClockOutTime: this.$store.state.userSettings.reminders
        .clockout_reminder,
      selected: [],
      debounce: null,
    };
  },
  watch: {
    clockInReminder: function(newVal, oldVal) {
      const time = this.$moment(newVal, "hh:mm:ss");
      if (!time.isValid()) {
        this.clockInReminder = oldVal;
      } else {
        this.userSettings.reminders.clockin_reminder = time.format("hh:mm");
        if (
          this.userSettings.reminders.clockin_reminder !== this.oldClockInTime
        ) {
          this.saveChanges();
        }
      }
    },
    clockOutReminder: function(newVal, oldVal) {
      const time = this.$moment(newVal, "hh:mm:ss");
      if (!time.isValid()) {
        this.clockOutReminder = oldVal;
      } else {
        this.userSettings.reminders.clockout_reminder = time.format("hh:mm");
        if (
          this.userSettings.reminders.clockout_reminder !== this.oldClockOutTime
        ) {
          this.saveChanges();
        }
      }
    },
  },
  methods: {
    saveChanges() {
      if (this.debounce) {
        clearTimeout(this.debounce);
      }

      const _this = this;
      if (_this.userSettings.clockin_reminder_check) {
        const time = this.$moment(_this.userSettings.clockin_reminder, "hh:mm");
        if (!time.isValid()) {
          this.userSettings.clockin_reminder = this.clockInReminder;
          return false;
        }
      }
      if (_this.userSettings.clockout_reminder_check) {
        const time = this.$moment(
          _this.userSettings.clockout_reminder,
          "hh:mm"
        );
        if (!time.isValid()) {
          this.userSettings.clockOut_reminder = this.clockOutReminder;
          return false;
        }
      }

      _this.debounce = setTimeout(() => {
        UserService.saveUserSettings(_this.userSettings)
          .then((response) => {
            console.log(response);

            this.$awn.success(response.data.message);
          })
          .catch((error) => {
            console.log(error);
          });
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.subsection-wrapper {
  padding: 40px 0;

  &.reminders {
    padding: 40px;
    max-width: 670px;
    width: 100%;

    .separator-line {
      width: 80px;
      margin-left: 40px;
    }
  }

  &.notifications {
    padding: 40px 40px 24px;
  }

  .wrapper-title {
    margin-bottom: 40px;
  }

  .separator-line {
    height: 2px;
    background-color: #efefef;
    margin: 40px 0;
    border: 0;
  }

  .field-wrap {
    margin-bottom: 16px;
    min-height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;

    p {
      margin-bottom: 0;
    }

    .time-reminder {
      display: inline-flex;
      align-items: center;
      margin-left: auto;
      position: relative;

      i {
        font-size: 16px;
        color: #262626;
        margin-right: 16px;
        width: 24px;
        height: 24px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        &:before {
          font-size: 0.6875rem;
        }
      }

      .remind-me {
        margin-right: 16px;
        min-width: 113px;
        display: inline-flex;
        font: 400 0.875rem/1.75rem "Roboto", sans-serif;
        color: #262626;
      }

      input {
        padding: 6px 6px 6px 10px;
        border: 2px solid #f7f7f7;
        width: 80px;
        font: $roboto-medium 0.875rem/1.5rem $roboto-font;
        color: $atto-font-color;

        &:focus {
          border-color: #00b9cb;
        }
        &::selection {
          background-color: rgba(10, 212, 210, 0.25);
        }
      }

      span.input-overlay {
        display: none;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        height: 40px;
      }

      &.disabled {
        i,
        span.remind-me {
          color: #c7c7c7;
        }

        input {
          border-color: #efefef;
          color: #999;
        }
        span.input-overlay {
          display: block;
        }
      }
    }

    &.mb-32 {
      margin-bottom: 32px;
    }
  }

  .reminding-days {
    display: flex;
    flex-direction: column;
    padding-left: 40px;

    span.label {
      font: $roboto-regular 0.875rem/1.75rem $roboto-font;
      color: #262626;
      margin-bottom: 12px;
    }

    p {
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 400;
      font-family: "Roboto", sans-serif;
      color: #999;
      margin-bottom: 0;
    }
  }

  .check-wrapper {
    p {
      padding-left: 40px;
      font: $roboto-regular 0.875rem/1.25rem $roboto-font;
      color: #666666;
      margin-top: 4px;
    }
  }
}
</style>
<style lang="scss">
.notifications,
.reminders {
  .check-wrapper {
    .custom-checkbox {
      .custom-control-label {
        font: $roboto-regular 0.875rem/1.75rem $roboto-font;

        &:before {
          border-radius: 0;
        }
      }
    }
  }
}
ul.reminders-day-list li .btn {
  height: 50px !important;
  padding: 13px 22px 13px 21px;
  font: $roboto-regular 0.875rem/1.5rem $roboto-font;
}
</style>
<style lang="scss">
@media (max-width: 1187px) {
  .notifications
    .col-md-4
    .check-wrapper
    .custom-checkbox
    .custom-control-label {
    max-width: 125px;
  }
}
@media (max-width: 1050px) {
  ul.day-list li .btn {
    width: 65px !important;
  }
}
</style>
